import { render, staticRenderFns } from "./viz-item.vue?vue&type=template&id=353b1ff0"
import script from "./viz-item.vue?vue&type=script&lang=js"
export * from "./viz-item.vue?vue&type=script&lang=js"
import style0 from "./viz-item.vue?vue&type=style&index=0&id=353b1ff0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports